import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from '@bugsnag/browser-performance';

const apiKey = '1d635f21ed193550730921d32c531260';
const appVersion = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '1.0.0';
const allowedStages = ['production', 'staging'];

function getReleaseStage() {
  const host = window.location.hostname || '';
  if (host === 'localhost' || host === '127.0.0.1') return 'development';
  if (host.endsWith('.vercel.app') || host.includes('preview')) return 'staging';
  return 'production';
}

const releaseStage = getReleaseStage();

if (allowedStages.includes(releaseStage)) {
  Bugsnag.start({
    apiKey,
    appVersion,
    releaseStage,
    enabledReleaseStages: allowedStages,
    autoTrackSessions: true,
    enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'process', 'request', 'state', 'user'],
    metadata: {
      site: {
        hostname: window.location.hostname,
        path: window.location.pathname
      }
    }
  });

  BugsnagPerformance.start({
    apiKey,
    appVersion,
    releaseStage
  });
}
